<template>
  <div>
    <page-title icon="fas fa-address-card" main="PPR"> 
       <template v-slot:actions>
        <base-button
          onclick="window.open('http://www.planalto.gov.br/ccivil_03/leis/l10101compilado.htm')"
          type="info"
          class="ml-3"
          size="sm"
          >Lei 10.101/2000</base-button
        >
      </template>
    </page-title>
    <card>
      <div slot="header">
        <p>Programa de participação nos lucros ou resultados</p>
      </div>
      <form v-loading="loading">
        <div class="row">
          <img
            :src="logo"
            class="card-img-center" 
            style="width: 30%; margin: auto;" 
          />
          <div class="col-md-12">
            <div v-for="(setting_options, setting_category, index) in setting" :key=index>
              <div class="row">
                <div class="col-md-6" v-for="(setting_value, setting_name, inner_index) in setting_options" :key=inner_index>
                  <base-input 
                    addon-left-icon="ni ni-calendar-grid-58"
                    :label="setting_value.localization"
                    v-if="setting_value.type == 'date'"
                    >
                    <flat-picker
                      class="form-control datepicker"
                      :config="{allowInput: true, dateFormat: 'd/m/Y'}"
                      v-model="setting[setting_category][setting_name].value"
                      @on-change="prepareSave"
                    ></flat-picker>
                  </base-input>
                </div>
              </div>
            </div>
          </div>
        </div>  
      </form>
    </card>
  </div>
</template>

<script>
  import Vue from "vue";
  import PageTitle from "@/layouts/PageTitle";
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";

  export default {
    name: "app",
    components: {
      PageTitle,
      flatPicker,
    },
    data() {
      return {
        loading: true, 
        setting_attributes: [],
        setting: {},
        translation: {
          'goal_periods': 'Periodos de Metas', 
          'mail_options': 'Opções de Email',
          'avaliation_review': 'Opções de Avaliações',
        }
      }
    },
    mounted() {
      this.getSettingsAttributes();
    },
    methods: {
      getSettingsAttributes(){
        console.log('get')
      },
      prepareSave(){
        this.$nextTick(this.save)
      },
      save(){
        console.log('get')
      },
    },
    computed: {
      setting_image() {
        return this.$store.state.imageSettings || {}
      },
      logo() {
        if (this.loading) return "";

        return this.setting_image.logo_sgv && this.setting_image.logo_sgv.value
          ? this.setting_image.logo_sgv.value
          : "/img/brand/top-logo.png";
      }
    },
    watch: {
      'setting_image': {
        handler(newValue) {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        },
        deep: true,
        immediate: true
      }
    },
  };
</script>

<style scoped>
#card {
  justify-content: center;
  align-content: center;
  align-items: center;
}
</style>